import LocalStorage from 'services/LocalStorage'
import { LocalStorageKey } from 'types/services/localStorage'

export function getRandomBool() {
  return Math.random() >= 0.5
}

export function getUserABGroup() {
  const userGroup = LocalStorage.get(LocalStorageKey.USER_AB_GROUP_ONBOARDING)

  if (!userGroup) {
    LocalStorage.set(LocalStorageKey.USER_AB_GROUP_ONBOARDING, 'A')
  }

  return LocalStorage.get(LocalStorageKey.USER_AB_GROUP_ONBOARDING)
}
